import img1 from "../Images/1.webp";
import img2 from "../Images/2.webp";
import img3 from "../Images/3.webp";
import img4 from "../Images/4.png";
import img6 from "../Images/6.png";
import img5 from "../Images/5.png";
import img7 from "../Images/7.webp";

/** Images for the auto-scrolling strip under the home page hero. */
export const MARQUEE_IMAGES = [
  { src: img1, alt: "Phone mockup on dark surface" },
  { src: img2, alt: "iPhone lying on light surface" },
  { src: img3, alt: "Mobile UI close-up" },
  { src: img4, alt: "Device display detail" },
  { src: img5, alt: "App screen on phone" },
  { src: img6, alt: "iPhone close-up angle" },
  { src: img7, alt: "iPhone close-up angle" },
];
